export const getFullSearchTerm = (searchTerm: string) => `
  (name: (${searchTerm}*) OR description: (${searchTerm}*)) AND type: STOCK AND status: ACTIVE
`;
